import { $http } from "@/plugins/axios";
import users from "./modules/users";
import services from "./modules/services";
import requests from "./modules/requests";
import companyInfo from "./modules/companyInfo";
export default {
  namespaced: true,
  modules: {
    users,
    services,
    companyInfo,
    requests,
  },
  state: {
    statistics: {
      count: {},
      bank_visits: {},
    },
  },
  mutations: {
    SET_STATISTICS: (state, data) => (state.statistics = data),
  },
  actions: {
    async get({ commit }) {
      const { payload } = await $http.get(`bank-admin/statistics`);
      commit("SET_STATISTICS", payload);
    },
  },
};
